import axios from './index'


// 用户登录
export function login(url,params) {
    return axios({
        url,
        method: "get",
        params
    })
}

// 添加公司
export function addCompany(data) {
    return axios({
        url: '/allCompanys',
        method: "post",
        data
    })
}
// 查询公司列表
export function getCompanyList(url,params) {
    return axios({
        url,
        method: "get",
        params

    })
}
// 编辑公司
export function EditCompany(data) {
    return axios({
        url: '/allCompanys',
        method: "put",
        data
    })
}
// 删除公司
export function delCompany(params) {
    return axios({
        url: '/allCompanys',
        method: "delete",
        params
    })
}

// 查询公司广告列表
export function getAdvertisementList(params) {
    return axios({
        url: '/advertisement',
        method: "get",
        params

    })
}

// 添加广告
export function addAdvertisement(data) {
    return axios({
        url: '/advertisement',
        method: "post",
        data,
        headers: {
            'Content-Type': "multipart/form-data"
          },
      
    })
}



 


// WEBPACK FOOTER //
// ./src/api/api.js